import upload from './upload'
// const rootPath = 'http://10.15.255.12:9003/qcx';
const sso = true
// const rootPath = 'http://10.15.12.60:6100'
// const rootPath = 'http://192.168.5.60:6100'
// const rootPath = 'http://192.168.100.150:6100'
const rootPath = '/qcx'
// const rootPath = 'http://2968391i5b.wicp.vip'
const rootNewsPath = 'http://192.168.1.92:8800'
export default {
  rootPath,
  sso,
  upload,
  rootNewsPath
}



// WEBPACK FOOTER //
// ./src/api/mainApi.js